import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"x-small":"","color":_vm.$store.getters.getConf.theme_dark ? 'grey darken-4' : 'grey lighten-1',"dark":"","outlined":""},on:{"click":function($event){$event.preventDefault();return _vm.themeDarkAction.apply(null, arguments)}}},[_vm._v(" Modo: "+_vm._s(_vm.$store.getters.getConf.theme_dark ? "Obscuro" : "Claro")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }